module.exports = __webpack_public_path__ + "files/e14f8bb7ff590666d4647e1cba6b4b93.png";